export default "https://legacy.eskolare-development.com/images/glyphs-hero.png";